import { z } from "zod";

export const getClosestMileagePayloadSchema = z.object({
  companyUuid: z.uuid().optional(),
  date: z.iso.datetime(),
});

export type GetClosestMileagePayload = z.infer<
  typeof getClosestMileagePayloadSchema
>;
